import { uid } from "@xbs/lib-state";
import { defaultEditorShape } from "./constants";
export function isSameId(firstId, secondId) {
    if (!firstId || !secondId) {
        return false;
    }
    return firstId == secondId;
}
export function byId(data, id) {
    return data.find(el => isSameId(el.id, id));
}
export function includesId(data, id) {
    return !!data?.find(el => isSameId(el, id));
}
export function getVisibleCards(state) {
    return Object.keys(state.cardsMap).reduce((acc, key) => {
        return acc.concat(state.cardsMap[key]);
    }, []);
}
export function getAreaId(columnId, rowId) {
    return `${columnId}` + (rowId ? `:${rowId}` : "");
}
export function splitAreaId(areaId) {
    return areaId.split(/(?<!temp):(?!\/\/)/);
}
export function getCardAreaId(card, columnKey, rowKey) {
    if (rowKey) {
        return card[columnKey] + ":" + card[rowKey];
    }
    else {
        return card[columnKey];
    }
}
export function checkScroll(e, el, config = { shift: 20 }) {
    let scrollTimer = null;
    function scroll() {
        if (el) {
            const contentRect = el.getBoundingClientRect();
            const scrollState = {
                x: el.scrollLeft,
                y: el.scrollTop,
            };
            const { shift } = config;
            if (e.clientX > contentRect.width + contentRect.left - shift) {
                el.scrollTo(scrollState.x + shift, scrollState.y);
            }
            if (e.clientX < contentRect.left + shift) {
                el.scrollTo(scrollState.x - shift, scrollState.y);
            }
            if (e.clientY > contentRect.height + contentRect.top - shift) {
                el.scrollTo(scrollState.x, scrollState.y + shift);
            }
            if (e.clientY < contentRect.top + shift) {
                el.scrollTo(scrollState.x, scrollState.y - shift);
            }
            scrollTimer = setTimeout(() => {
                scroll();
            }, 100);
        }
    }
    scroll();
    return () => {
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }
    };
}
export function normalizeMenuConfig(config) {
    var _a;
    const { shape, defaultMenuItems, store } = config;
    const nShape = shape || {};
    if (nShape.menu === false) {
        return {
            menu: {
                show: false,
                items: () => null,
            },
        };
    }
    nShape.menu || (nShape.menu = {});
    if (Array.isArray(nShape.menu.items)) {
        const items = [...nShape.menu.items];
        nShape.menu.items = () => items;
    }
    const menuItemsFn = nShape.menu.items || defaultMenuItems;
    nShape.menu.items = (config) => {
        let menu = menuItemsFn({ ...config, store });
        if (menu)
            menu = getNormalizedMenuItems(menu);
        return menu;
    };
    (_a = nShape.menu).show ?? (_a.show = true);
    return nShape;
}
// [todo] label and items for submenus are deprecated and will be removed in later versions
function getNormalizedMenuItems(items) {
    return items.map(item => {
        const res = { ...item };
        if (item.items)
            res.data = item.items;
        if (res.data)
            res.data = getNormalizedMenuItems(res.data);
        if (item.label)
            res.text = item.label;
        return res;
    });
}
export function getSortedCards(state, sortRule) {
    const { cards, columnKey, sort } = state;
    if (!sort)
        return cards;
    const cardsByColumn = cards.reduce((a, c) => {
        a[c[columnKey]] = a[c[columnKey]] || [];
        a[c[columnKey]].push(c);
        return a;
    }, {});
    const getSortItem = (item, by) => `${typeof by === "function" ? by(item) : item[by]}`;
    Object.keys(cardsByColumn).forEach(columnId => {
        let sortConfig;
        if ("columns" in sort) {
            sortConfig = sort.columns[columnId] || {};
        }
        else {
            sortConfig = sort;
        }
        if (sortConfig.by) {
            sortRule =
                sortRule ||
                    ((config) => {
                        const { dir } = config;
                        const by = config.by;
                        return (a, b) => {
                            const first = getSortItem(a, by);
                            const second = getSortItem(b, by);
                            if (dir === "desc") {
                                return second.localeCompare(first, undefined, {
                                    numeric: true,
                                });
                            }
                            return first.localeCompare(second, undefined, {
                                numeric: true,
                            });
                        };
                    });
            const area = cardsByColumn[columnId];
            area.sort(sortRule(sortConfig));
        }
    });
    return Object.values(cardsByColumn).flat();
}
export function normalizeEditorShape(rawEditorShape, cardShape) {
    const editorShape = rawEditorShape ||
        defaultEditorShape.filter(field => {
            const cardField = cardShape[field.key];
            return cardField && cardField?.show;
        });
    return editorShape.map(field => {
        const cardField = cardShape[field.key];
        if (cardField && typeof field.key === "string") {
            if (cardField.values && !field.values) {
                field.values = cardField.values;
            }
            if (field.config) {
                cardField.config = field.config;
            }
        }
        field.id = field.id || uid();
        return field;
    });
}
let i = 0;
export function normalizeUsers(cardShape) {
    if (cardShape.users?.values) {
        cardShape.users.values.forEach(user => {
            if (!user.id)
                throw "Please provide user IDs";
            if (!user.avatar)
                user.avatarColor = ["#00D19A", "#2F77E3", "#FFC975"][Math.floor(i++ % 3)];
        });
    }
    return cardShape;
}
//# sourceMappingURL=helpers.js.map